module.exports = __webpack_public_path__ + "img/2025-10-15a_6.7d2ba1f1.jpg";